<template>
  <div class="member-homework-index">
    <el-tabs v-if="total>0" class="el-tabs-common" v-model="curTab" @tab-click="onChangeTab">
      <el-tab-pane
        v-for="(item, index) in tabs"
        :key="index"
        :name="item.name"
        :label="item.label+'（'+item.num+'）'"
      ></el-tab-pane>
    </el-tabs>
    <el-scrollbar :style="'height:calc('+$store.state.memberLeftHeight+'px - 76px - 99px);'">
      <div class="search" v-if="tabs.find(t=>t.name==curTab).num>0">
        <el-input v-model="search.title" placeholder="请输入课程关键字"></el-input>
        <el-button type="primary" size="mini" @click="onSearch">搜索</el-button>
        <el-button type="default" size="mini" @click="onReset">重置</el-button>
      </div>
      <list
        ref="list"
        url="/api/app/user/homework/list"
        :alwaysShowPager="false"
        :search="search"
        @page-load="onPageLoad"
      >
        <template>
          <div class="list" v-if="homeworks.length>0">
            <div class="homework-item" shadow="hover" v-for="(item) in homeworks" :key="item.id">
              <div class="left">
                <div class="title-wrap">
                  <span
                    class="status"
                    :class="'status-'+item.status"
                  >{{tabs.find(t=>t.name==item.status).label}}</span>
                  <span class="title">{{item.hw_name}}</span>
                </div>
                <div class="info">
                  <span
                    :class="{red:item.status==1&&item.end_time*1000-new Date().getTime()>=0&&item.end_time*1000-new Date().getTime()<=24*60*60*1000}"
                  >提交截止：{{item.end_time|tsFormat("yyyy/MM/dd hh:mm:ss")}}</span>
                  <template v-if="item.is_set_score==2">
                    <span class="line">|</span>
                    <span>总分：{{item.score}}</span>
                  </template>
                  <span class="line">|</span>
                  <span>{{item.ques_count}}道题</span>
                </div>
                <div class="info">所属课程：{{item.title}}</div>
                <div class="info">所属课时：{{item.periods_name||"-"}}</div>
              </div>
              <div class="right">
                <div class="link-wrap">
                  <div v-if="item.status==3&&item.is_set_score==2" class="score">{{item.user_score}}</div>
                  <router-link
                    class="link link-do"
                    v-if="item.status==1"
                    :to="{name:'HomeworkIntro',query:{id:item.id}}"
                  >开始答题</router-link>
                  <router-link
                    class="link link-detail"
                    v-else-if="item.status!=5"
                    :to="{name:'HomeworkAnalysis',query:{id:item.id}}"
                  >查看详情</router-link>
                  <a class="link link-disabled" v-else>查看详情</a>
                </div>
                <div class="publish-time">{{item.created_at|tsFormat("yyyy/MM/dd hh:mm")}}发布</div>
              </div>
            </div>
          </div>
          <div v-else class="empty">
            <img src="@/assets/images/homework/empty.png" />
            <div
              class="text"
            >{{homeworks.length>0&&curTab!="0"?'暂无'+(tabs.find(t=>t.name==curTab).label)+'作业哦':'暂无作业哦'}}</div>
          </div>
        </template>
      </list>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: "member-homework-index",
  data() {
    return {
      curTab: "1",
      tabs: [
        { label: "待提交", name: "1", num: 0 },
        { label: "待批改", name: "2", num: 0 },
        { label: "已批改", name: "3", num: 0 },
        { label: "已过期", name: "4", num: 0 },
        { label: "已撤回", name: "5", num: 0 },
        { label: "全部", name: "0", num: 0 }
      ],
      homeworks: [],
      search: {
        title: "",
        status: 1
      },
      total: 0
    };
  },
  async created() {
    let data = await this.$http.get("/api/app/user/homework/listNum");
    this.tabs.find(t => t.name == 1).num = data.no_submit_num;
    this.tabs.find(t => t.name == 2).num = data.submit_num;
    this.tabs.find(t => t.name == 3).num = data.correction_num;
    this.tabs.find(t => t.name == 4).num = data.expired_num;
    this.tabs.find(t => t.name == 5).num = data.callback_num;
    this.tabs.find(t => t.name == 0).num = data.total_num;
    this.total = data.total_num;
  },
  methods: {
    onChangeTab({ name }) {
      this.search.status = name;
      this.onSearch();
    },
    onPageLoad({ list }) {
      this.homeworks = list;
    },
    onSearch() {
      this.$refs.list.searchRefresh();
    },
    onReset() {
      this.search.title = "";
      this.onSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.member-homework-index {
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  padding: 10px 0 30px 0;

  .el-tabs-common,
  .search,
  .list {
    margin: 0 24px 0 26px;
  }

  /deep/ {
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }

  .list {
    padding-bottom: 30px;
  }

  .homework-item {
    padding: 20px 0;
    background: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    position: relative;
    border-bottom: 1px solid #ededed;
    display: flex;
    align-items: center;

    .left {
      flex-grow: 1;
    }

    .title-wrap {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }

    .status {
      width: 50px;
      height: 20px;
      background: rgba(255, 45, 40, 1);
      border-radius: 3px;
      font-size: 13px;
      color: white;
      line-height: 20px;
      text-align: center;
      margin-right: 8px;
    }

    .status-2 {
      background: #fcc41a;
    }

    .status-3 {
      background: #13cc59;
    }

    .status-4,
    .status-5 {
      background: #e6e6e6;
      color: #999999;
    }

    .title {
      font-size: 14px;
    }

    .info {
      font-size: 13px;
      color: #999999;
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0;
      }

      .line {
        margin: 0 10px;
      }

      .red {
        color: red;
      }
    }

    .right {
      width: 160px;
      display: flex;
      flex-direction: column;
    }

    .link-wrap {
      display: flex;
      margin-bottom: 26px;
      justify-content: flex-end;
    }

    .score {
      width: 42px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 1;
      text-align: center;
      color: #ff2d28;
      background-image: url("~@/assets/images/homework/score-line@2x.png");
      background-position: center bottom;
      background-size: 42px 13px;
      background-repeat: no-repeat;
      margin-right: 11px;
    }

    .link {
      width: 86px;
      height: 32px;
      background: $primary-color;
      border: 1px solid $primary-color;
      border-radius: 3px;
      font-size: 14px;
      text-align: center;
      line-height: 30px;
      color: white;
      box-sizing: border-box;
      margin-right: 21px;
    }

    .link-detail {
      background: white;
      color: $primary-color;
    }

    .link-disabled {
      cursor: not-allowed;
      background: #e6e6e6;
      color: #999999;
      border-color: #e6e6e6;
    }

    .publish-time {
      font-size: 13px;
      color: #999999;
      text-align: right;
    }
  }
}
.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  position: relative;

  img {
    width: 484px;
  }

  .text {
    font-size: 16px;
    color: #666666;
    position: absolute;
    bottom: 91px;
  }
}
.el-tabs-common {
  /deep/ {
    .el-tabs__item.is-active::after {
      width: 50px;
      transform: none;
      left: 11px;
    }
  }
}
.search {
  display: flex;
  align-items: center;

  /deep/ {
    .el-input {
      width: 219px;
      margin-right: 10px;
    }
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
